import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { StatusDocumento } from '../models/status-documento.model';

export const EVENTO_REPOSITORY = new InjectionToken<EventoRepository>('EventoRepository');

export interface EventoRepository {
  listarTiposFeedbacksDocumento(): Observable<StatusDocumento[]>;
}
